import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "material-gallery"
};
const _hoisted_2 = {
  class: "gallery-tabs"
};
const _hoisted_3 = {
  class: "tabs-left"
};
const _hoisted_4 = {
  style: {
    "font-size": "14px",
    "padding": "0 10px"
  }
};
const _hoisted_5 = {
  class: "tabs-right"
};
const _hoisted_6 = {
  key: 0,
  class: "gallery-body",
  "infinite-scroll-delay": 1000,
  "infinite-scroll-distance": 20,
  "infinite-scroll-immediate": false
};
const _hoisted_7 = {
  class: "gallery-body-wrap"
};
const _hoisted_8 = {
  class: "card-item-content"
};
const _hoisted_9 = {
  class: "video-bottom"
};
const _hoisted_10 = {
  class: "video-bottom-left"
};
const _hoisted_11 = {
  class: "video-bottom-right"
};
const _hoisted_12 = {
  class: "card-item-shade"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "card-item-content"
};
const _hoisted_15 = {
  class: "video-bottom"
};
const _hoisted_16 = {
  class: "video-bottom-left"
};
const _hoisted_17 = {
  class: "video-bottom-right"
};
const _hoisted_18 = {
  class: "card-item-shade"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "card-item-content"
};
const _hoisted_21 = {
  class: "video-bottom"
};
const _hoisted_22 = {
  class: "video-bottom-left"
};
const _hoisted_23 = {
  class: "video-bottom-right"
};
const _hoisted_24 = {
  class: "card-item-shade"
};
const _hoisted_25 = {
  key: 0,
  class: "no-more-data"
};
const _hoisted_26 = {
  key: 1,
  style: {
    "height": "600px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
};
import { nextTick } from 'vue';
import CardItem from '@/components/AssetsCardList/CardItem.vue';
import MaterialUploadDialog from './MaterialUploadDialog.vue';
import { addUserResourceLibrary, getTeamMedia, deleteUserResourceLibrary } from '@/request/index';
import { getMultimediaCategoriesType } from '@/request/multimediaCategories';
import { ref, watch, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox, ElIcon, ElSelect, ElOption } from 'element-plus';
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'
import 'element-plus/es/components/icon/style/index'
import 'element-plus/es/components/select/style/index'
import 'element-plus/es/components/option/style/index'

import { Delete, UploadFilled } from '@element-plus/icons-vue';
import DirectUploader from '@/components/DirectUploader/index.vue';
import VideoPlayer from '@/components/MediaPlayer/VideoPlayer.vue';
import { useAudioPlayer } from '@/hooks/useAudioPlayer.ts';
import { deleteMultiMedia } from '@/request/aiClip';

// 视频类型

export default {
  __name: 'MaterialGallery',
  props: {
    isMultipleSelection: {
      type: Boolean,
      // true 表示多选，false 表示单选
      default: false
    },
    editMode: {
      type: Boolean,
      // 编辑模式
      default: false
    },
    showTabs: {
      type: Array,
      // 控制显示的tabs
      default: () => []
    }
  },
  emits: ['changeItemFn'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const videoTypeOptions = [{
      label: '横屏',
      value: '横屏'
    }, {
      label: '竖屏',
      value: '竖屏'
    }];

    // 事件
    const emits = __emit;

    // 属性
    const props = __props;

    // ref
    const materialUploadDialog = ref(null); // 上传素材对话框

    const audioUrl = ref(null); // 音频播放
    const {
      isPlaying,
      toggle
    } = useAudioPlayer(); // 音频播放
    let showImageArr = ref([]); // 预览图片
    let showImageViewer = ref(false); // 预览图片
    let currentPageIndex = ref(1); // 当前页
    let currentPageSize = ref(36); // 每页数量
    let currentTab = ref(''); // 当前tab
    let materialType = ref(''); // 素材类型 横屏 竖屏
    let listNoMore = ref(false); // 是否没有更多数据
    let uploadLoading = ref(false); // 上传加载
    let materialListLoading = ref(false); // 列表加载
    let materialArr = ref([]); // 列表
    let typeOptions = ref([]); // 多媒体类型
    let keywords = ref(''); // 关键词

    // 分类 1：音频，2：视频，3：贴图，4：音乐 5:背景
    const typeOptionsUploadRules = [{
      name: '全部',
      value: ''
    }, {
      name: '装饰',
      value: 5,
      uploadRules: {
        sizeMb: 5,
        type: ['png', 'jpg', 'jpeg']
      }
    }, {
      name: '视频',
      value: 1,
      uploadRules: {
        sizeMb: 100,
        type: ['mp4']
      }
    }, {
      name: '音频',
      value: 4,
      uploadRules: {
        sizeMb: 15,
        type: ['mp3', 'mpeg']
      }
    }, {
      name: '音乐',
      value: 6,
      uploadRules: {
        sizeMb: 15,
        type: ['mp3', 'mpeg']
      }
    }, {
      name: '背景',
      value: 3,
      uploadRules: {
        sizeMb: 5,
        type: ['png', 'jpg', 'jpeg', 'mp4', 'gif']
      }
    }];

    // computed 过滤tabs
    const filteredTypeOptions = computed(() => {
      return typeOptions.value.filter(option => props.showTabs.includes(option.name));
    });

    // 搜索
    const handleSearch = () => {
      resetListFn();
    };

    // 使用文件名作为title，增加容错处理
    const getName = url => {
      if (!url) return '未命名'; // 如果URL为空，返回默认名称
      try {
        const parts = url.split('/').pop().split('.');
        if (parts.length > 1) parts.pop(); // 移除扩展名
        return parts.join('.') || '未命名'; // 如果结果为空，返回默认名称
      } catch (error) {
        console.error('Error parsing URL:', error);
        return '未命名'; // 解析出错时返回
      }
    };
    // 初始化
    onMounted(async () => {
      // 获取多媒体类型
      await fetchMultimediaTypes();
      nextTick(async () => {
        let item = filteredTypeOptions.value[0];
        currentTab.value = (item === null || item === void 0 ? void 0 : item.value) || '';
        let data = await getUserResourceLibraryPageFn();
        materialArr.value = data.list;
      });
    });

    // 打开上传素材对话框
    const openUploadDialog = (uploadItem = null) => {
      // 找到当前对应的typeOptions
      let typeOption = typeOptions.value.find(v => v.value === currentTab.value);
      materialUploadDialog.value.openDialog(typeOption, uploadItem);
    };

    // 获取多媒体类型
    const fetchMultimediaTypes = async () => {
      try {
        const res = await getMultimediaCategoriesType();
        const {
          code,
          data
        } = res.data;
        if (code == 200) {
          typeOptions.value = data;
          mergeTypeOptions();
        }
      } catch (err) {
        console.error("获取多媒体类型失败", err);
      }
    };

    // 合并typeOptions和typeOptionsUploadRules
    const mergeTypeOptions = () => {
      // 创建一个新数组，用于存储合并后的结果
      const mergedOptions = [];

      // 遍历本地定义的规则数组
      typeOptionsUploadRules.forEach(localOption => {
        // 查找 API 数据中是否有匹配的项
        const apiOption = typeOptions.value.find(apiItem => apiItem.value === localOption.value);
        if (apiOption) {
          // 如果找到匹配项，合并两个对象
          mergedOptions.push({
            ...apiOption,
            // 从 API 获取的数据
            uploadRules: localOption.uploadRules // 确保 uploadRules 被包含
          });
        } else {
          // 如果没有找到匹配项，直接添加本地定义的项
          mergedOptions.push(localOption);
        }
      });
      // 更新 typeOptions.value 为合并后的结果
      typeOptions.value = mergedOptions;
    };
    const addUserResource = (name, url, type = currentTab.value) => {
      addUserResourceLibrary({
        type,
        name,
        url
      }).then(res => {
        if (res.data.code == 200) {
          resetListFn();
        }
      }).catch(err => {
        console.error("添加失败！", err);
      });
    };
    let getUserResourceLibraryPageFn = async (obj = null) => {
      try {
        materialListLoading.value = true;
        // 参数
        const params = {
          pageIndex: currentPageIndex.value,
          pageSize: currentPageSize.value,
          keyword: keywords.value,
          mediaType: currentTab.value,
          screen: materialType.value
        };
        let {
          data
        } = await getTeamMedia(obj || params);
        if (data.code == 200) {
          let {
            list,
            total
          } = data.data;
          console.log(list, 'list');
          list.map(v => ({
            ...v,
            title: v.name ? v.name.slice(0, v.name.lastIndexOf('.')) : '',
            checked: false
          }));
          materialListLoading.value = false;
          return {
            list,
            total
          };
        }
        materialListLoading.value = false;
      } catch (err) {
        console.log(err, 'getUserResourceLibraryPageFn');
        materialListLoading.value = false;
        console.error("获取列表失败", err);
      }
    };

    // 删除
    let deleteItemFn = item => {
      ElMessageBox.confirm('确定删除该文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // console.log(item, 'deleteItemFn');
        let res = await deleteMultiMedia(item.id);
        const {
          code,
          msg
        } = res.data;
        ElMessage({
          type: code == 200 ? 'success' : 'error',
          message: msg
        });
        resetListFn();
      });
    };

    // 编辑
    let editItemFn = item => {
      openUploadDialog(item);
    };

    // 选中
    const selectItemFn = row => {
      if (props.isMultipleSelection) {
        row.checked = !row.checked;
      } else {
        if (row.checked) {
          row.checked = false;
        } else {
          materialArr.value.forEach(item => {
            item.checked = item === row;
          });
        }
      }
      emits('changeItemFn', row);
    };

    // 重置
    const resetListFn = async (obj = null) => {
      listNoMore.value = false;
      currentPageIndex.value = 1;
      materialArr.value = [];
      let data = await getUserResourceLibraryPageFn(obj);
      materialArr.value = data.list;
    };

    // 加载更多
    const handleInfiniteScroll = async () => {
      if (listNoMore.value) {
        return;
      }
      if (!listNoMore.value) {
        materialListLoading.value = true;
      }
      ++currentPageIndex.value;
      const data = await getUserResourceLibraryPageFn();
      // 如果实际请求的数量少于当前数量，说明没有更多数据了
      if (data.list.length < currentPageSize.value) {
        listNoMore.value = true;
      }
      materialArr.value = [...materialArr.value, ...data.list];
      materialListLoading.value = false;
    };

    // 切换tabs
    const changeTabFn = i => {
      currentTab.value = i;
      resetListFn();
    };

    // 关闭预览图片
    let closeShowImgFn = () => {
      showImageViewer.value = false;
    };
    // 预览图片
    let clickShowImgFn = url => {
      console.log('urlurl', url);
      showImageArr.value = [url];
      showImageViewer.value = true;
    };

    // 音乐播放
    let togglePlay = i => {
      if (!i.url) {
        ElMessage.error('音频文件不存在');
        return;
      }
      audioUrl.value = i.url;
      toggle(audioUrl.value);
    };
    let getSelectionFn = () => {
      return materialArr.value.filter(v => v.checked);
    };
    let getMaterialArrFn = () => {
      return materialArr.value;
    };
    __expose({
      getSelectionFn,
      getMaterialArrFn
    });
    return (_ctx, _cache) => {
      const _component_el_segmented = _resolveComponent("el-segmented");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_Edit = _resolveComponent("Edit");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_CircleCheckFilled = _resolveComponent("CircleCheckFilled");
      const _component_el_image = _resolveComponent("el-image");
      const _component_svgIcon = _resolveComponent("svgIcon");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_segmented, {
        size: "default",
        block: "",
        modelValue: _unref(currentTab),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currentTab) ? currentTab.value = $event : currentTab = $event),
        options: filteredTypeOptions.value,
        onChange: changeTabFn
      }, {
        default: _withCtx(({
          item
        }) => [_createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1)]),
        _: 1
      }, 8, ["modelValue", "options"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
        clearable: "",
        modelValue: _unref(keywords),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(keywords) ? keywords.value = $event : keywords = $event),
        style: {
          "max-width": "600px"
        },
        placeholder: "输入关键词进行搜索"
      }, {
        append: _withCtx(() => [_createVNode(_component_el_button, {
          class: "search-button",
          onClick: handleSearch,
          type: "primary"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("i", {
            class: "ri-search-line"
          }, null, -1)])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = $event => openUploadDialog()),
        style: {
          "margin-left": "10px"
        }
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 上传素材 ")])),
        _: 1
      })], 512), [[_vShow, _unref(currentTab)]])])]), _unref(materialArr).length ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(materialArr), i => {
          return _openBlock(), _createBlock(_component_el_col, {
            xs: 24,
            sm: 12,
            md: 8,
            lg: 4,
            xl: 4,
            class: "list-item-wrap",
            key: i.id
          }, {
            default: _withCtx(() => [[1].includes(Number(i.mediaType)) ? (_openBlock(), _createBlock(CardItem, {
              class: _normalizeClass(["list-item", {
                'list-item-active': i.checked
              }]),
              key: i,
              src: i.url,
              title: i.title
            }, {
              content: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(VideoPlayer, {
                "video-url": i.url,
                id: 'videoPlayer' + i.id,
                "plays-inline": true
              }, null, 8, ["video-url", "id"])])]),
              "card-bottom": _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(i.name || getName(i.url)), 1), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_dropdown, {
                size: "default"
              }, {
                dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                    onClick: $event => _unref(deleteItemFn)(i)
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [_createVNode(_unref(Delete))]),
                      _: 1
                    }), _cache[8] || (_cache[8] = _createTextVNode("删除"))]),
                    _: 2
                  }, 1032, ["onClick"]), _createVNode(_component_el_dropdown_item, {
                    onClick: $event => _unref(editItemFn)(i)
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [_createVNode(_component_Edit)]),
                      _: 1
                    }), _cache[9] || (_cache[9] = _createTextVNode("编辑"))]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)]),
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "el-dropdown-link",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                }, "···")]),
                _: 2
              }, 1024)])])]),
              "shade-content": _withCtx(() => [_createElementVNode("div", _hoisted_12, [__props.editMode ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "checked-button",
                onClick: $event => selectItemFn(i)
              }, [_createVNode(_unref(ElIcon), {
                style: _normalizeStyle({
                  color: i.checked ? '#5754f9' : '#383943'
                }),
                size: "18"
              }, {
                default: _withCtx(() => [_createVNode(_component_CircleCheckFilled)]),
                _: 2
              }, 1032, ["style"])], 8, _hoisted_13)) : _createCommentVNode("", true)])]),
              _: 2
            }, 1032, ["class", "src", "title"])) : _createCommentVNode("", true), [3, 5, 6].includes(Number(i.mediaType)) ? (_openBlock(), _createBlock(CardItem, {
              class: "list-item",
              key: i,
              src: i.url,
              title: i.title
            }, {
              content: _withCtx(() => [_createElementVNode("div", _hoisted_14, [i.extension && ['mp4'].includes(i.extension.toLowerCase()) ? (_openBlock(), _createBlock(VideoPlayer, {
                key: 0,
                "video-url": i.url,
                id: 'videoPlayer' + i.id,
                "plays-inline": true
              }, null, 8, ["video-url", "id"])) : (_openBlock(), _createBlock(_component_el_image, {
                key: 1,
                style: {
                  "width": "100%",
                  "height": "100%",
                  "background": "#000"
                },
                src: i.url,
                fit: "contain",
                onClick: $event => _unref(clickShowImgFn)(i.url)
              }, null, 8, ["src", "onClick"]))])]),
              "card-bottom": _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(i.name || getName(i.url)), 1), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_dropdown, {
                size: "default"
              }, {
                dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                    onClick: $event => _unref(deleteItemFn)(i)
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [_createVNode(_unref(Delete))]),
                      _: 1
                    }), _cache[10] || (_cache[10] = _createTextVNode("删除"))]),
                    _: 2
                  }, 1032, ["onClick"]), _createVNode(_component_el_dropdown_item, {
                    onClick: $event => _unref(editItemFn)(i)
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [_createVNode(_component_Edit)]),
                      _: 1
                    }), _cache[11] || (_cache[11] = _createTextVNode("编辑"))]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)]),
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "el-dropdown-link",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, "···")]),
                _: 2
              }, 1024)])])]),
              "shade-content": _withCtx(() => [_createElementVNode("div", _hoisted_18, [__props.editMode ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "checked-button",
                onClick: $event => selectItemFn(i)
              }, [_createVNode(_unref(ElIcon), {
                style: _normalizeStyle({
                  color: i.checked ? '#5754f9' : '#383943'
                }),
                size: "18"
              }, {
                default: _withCtx(() => [_createVNode(_component_CircleCheckFilled)]),
                _: 2
              }, 1032, ["style"])], 8, _hoisted_19)) : _createCommentVNode("", true)])]),
              _: 2
            }, 1032, ["src", "title"])) : _createCommentVNode("", true), [2, 4].includes(Number(i.mediaType)) ? (_openBlock(), _createBlock(CardItem, {
              class: "list-item",
              key: i,
              src: i.url,
              title: i.title
            }, {
              content: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_image, {
                class: _normalizeClass(["music-image", {
                  rotating: _unref(isPlaying) && audioUrl.value === i.url
                }]),
                src: require('@/assets/images/music.png'),
                fit: "contain"
              }, null, 8, ["class", "src"])])]),
              "card-bottom": _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(i.name || getName(i.url)), 1), _createElementVNode("div", _hoisted_23, [_createVNode(_component_el_dropdown, {
                size: "default"
              }, {
                dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                    onClick: $event => _unref(deleteItemFn)(i)
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [_createVNode(_unref(Delete))]),
                      _: 1
                    }), _cache[12] || (_cache[12] = _createTextVNode("删除"))]),
                    _: 2
                  }, 1032, ["onClick"]), _createVNode(_component_el_dropdown_item, {
                    onClick: $event => _unref(editItemFn)(i)
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [_createVNode(_component_Edit)]),
                      _: 1
                    }), _cache[13] || (_cache[13] = _createTextVNode("编辑"))]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)]),
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "el-dropdown-link",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, "···")]),
                _: 2
              }, 1024)])])]),
              "shade-content": _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_svgIcon, {
                onClick: $event => _unref(togglePlay)(i),
                iconClass: _unref(isPlaying) && audioUrl.value === i.url ? 'pusewhite' : 'play',
                width: "35px",
                height: "35px"
              }, null, 8, ["onClick", "iconClass"])])]),
              _: 2
            }, 1032, ["src", "title"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]), _unref(listNoMore) ? (_openBlock(), _createElementBlock("div", _hoisted_25, " 没有更多数据了.... ")) : _createCommentVNode("", true)])), [[_directive_infinite_scroll, handleInfiniteScroll]]) : (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_el_empty, {
        description: "期待更多"
      })]))])), [[_directive_loading, _unref(materialListLoading)]]), _unref(showImageViewer) ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        "url-list": _unref(showImageArr),
        onClose: _unref(closeShowImgFn)
      }, null, 8, ["url-list", "onClose"])) : _createCommentVNode("", true), _createVNode(MaterialUploadDialog, {
        ref_key: "materialUploadDialog",
        ref: materialUploadDialog,
        onMaterialSuccess: resetListFn
      }, null, 512)], 64);
    };
  }
};